/** অর্ডার, ডেলিভারি জোন ও কাস্টমারের কনফার্মেশন পাতা। */
export const orders = {
    title: "অর্ডার",
    description: "অনলাইন ও ফোন অর্ডার: কনফার্ম, প্যাক, পাঠানো ও খোঁজ রাখা।",
    new: "নতুন অর্ডার",
    back: "সব অর্ডার",
    empty: "এখনো কোনো অর্ডার নেই।",
    conflict: "অন্য কেউ এই অর্ডার বদলেছেন। সর্বশেষ সংস্করণ দেখানো হচ্ছে; আবার চেষ্টা করুন।",
    filters: {
        status: "অবস্থা",
        channel: "চ্যানেল",
        phone: "ফোন",
        any: "সব",
        tag: "ট্যাগ",
        assignee: "দায়িত্বে",
        anyone: "যে কেউ",
        unassigned: "কেউ না",
        from: "থেকে",
        to: "পর্যন্ত",
        number: "অর্ডার নম্বর",
    },
    returns: {
        title: "ফেরত",
        description: "কাস্টমারের কাছ থেকে ফেরত আসা পণ্য ও পণ্য বদল।",
        empty: "এখনো কোনো ফেরত নেই।",
        newReturn: "ফেরত নিন",
        newExchange: "পণ্য বদল",
        titleReturn: "{{number}} থেকে ফেরত",
        titleExchange: "{{number}}-এর পণ্য বদল",
        lines: "যা ফেরত আসছে",
        sold: "বিক্রি {{qty}}, আগেই ফেরত {{returned}}",
        qtyBack: "ফেরতের পরিমাণ",
        condition: "অবস্থা",
        conditions: { sellable: "বিক্রয়যোগ্য (স্টকে ফেরত)", damaged: "নষ্ট (বাদ দেওয়া হবে)" },
        reason: "কারণ",
        reasons: {
            damaged: "নষ্ট",
            wrong_item: "ভুল পণ্য",
            not_as_described: "বর্ণনার সাথে মেলেনি",
            changed_mind: "মত বদলেছেন",
            late_delivery: "দেরিতে ডেলিভারি",
            other: "অন্য",
        },
        location: "স্টকে ফেরত যাবে",
        refundMethod: "টাকা ফেরত",
        refundMethods: {
            none: "টাকা ফেরত নয়",
            cash: "নগদ",
            bkash: "বিকাশ",
            nagad: "নগদ (মোবাইল)",
            bank: "ব্যাংক",
            store_credit: "স্টোর ক্রেডিট (বকেয়া কমবে)",
        },
        refundAmount: "ফেরতের টাকা",
        refundHint: "খালি = পণ্যের পুরো দাম।",
        newItems: "বদলি পণ্য",
        exchangeHint: "ফেরত পণ্যের দাম দিয়ে বদলি পণ্যের দাম মেটানো হবে; বাড়তি থাকলে ফেরত, কম পড়লে বাকি।",
        submitReturn: "ফেরত পোস্ট করুন",
        submitExchange: "পণ্য বদল পোস্ট করুন",
        nothing: "অন্তত একটি লাইনে পরিমাণ দিন।",
        posted: "ফেরত {{number}} পোস্ট হয়েছে।",
        exchanged: "পণ্য বদল পোস্ট হয়েছে: নতুন অর্ডার {{number}}।",
        kinds: { delivery_return: "কুরিয়ার ফেরত", customer_return: "কাস্টমার ফেরত", exchange: "পণ্য বদল" },
        columns: {
            number: "ফেরত",
            order: "অর্ডার",
            kind: "ধরন",
            reason: "কারণ",
            total: "দাম",
            refund: "টাকা ফেরত",
            date: "তারিখ",
        },
        value: "দাম",
        replacement: "বদলি অর্ডার",
    },
    desk: {
        labels: "ট্যাগ ও দায়িত্ব",
        tags: "ট্যাগ",
        tagsHint: "কমা দিয়ে আলাদা, সর্বোচ্চ ১০টি",
        assignee: "দায়িত্বে",
        unassigned: "কেউ না",
        save: "সংরক্ষণ",
        saved: "সংরক্ষিত হয়েছে।",
        notes: "ভেতরের নোট",
        notesHint: "শুধু আপনার টিম এগুলো দেখে।",
        noNotes: "এখনো কোনো নোট নেই।",
        addNote: "নোট যোগ",
        note: "নোট",
    },
    print: {
        title: "প্রিন্ট",
        invoice_a4: "ইনভয়েস (A4)",
        invoice_80mm: "ইনভয়েস (৮০ মিমি)",
        packing_slip: "প্যাকিং স্লিপ",
        pick_list: "পিক লিস্ট",
        working: "পিডিএফ তৈরি হচ্ছে…",
        ready: "আপনার পিডিএফ তৈরি।",
        open: "পিডিএফ খুলুন",
    },
    bulk: {
        selected: "{{count}}টি বাছাই করা",
        confirm: "কনফার্ম",
        status: "অবস্থা বদলান…",
        print: "প্রিন্ট…",
        done: "{{ok}}টি হয়েছে, {{failed}}টি হয়নি।",
    },
    views: {
        title: "সংরক্ষিত ভিউ",
        none: "সব অর্ডার",
        save: "ভিউ সংরক্ষণ",
        name: "ভিউয়ের নাম",
        shared: "টিমের সাথে শেয়ার করুন",
        delete: "ভিউ মুছুন",
        saved: "ভিউ সংরক্ষিত হয়েছে।",
        deleted: "ভিউ মুছে ফেলা হয়েছে।",
    },
    columns: {
        number: "অর্ডার",
        date: "তারিখ",
        phone: "ফোন",
        status: "অবস্থা",
        payment: "পেমেন্ট",
        total: "মোট",
        age: "অপেক্ষা",
    },
    status: {
        draft: "খসড়া",
        pending: "কনফার্মের অপেক্ষায়",
        confirmed: "কনফার্মড",
        packed: "প্যাক করা",
        shipped: "পাঠানো হয়েছে",
        delivered: "ডেলিভারি হয়েছে",
        partially_delivered: "আংশিক ডেলিভারি",
        returned: "ফেরত এসেছে",
        cancelled: "বাতিল",
    },
    payment: {
        unpaid: "অপরিশোধিত",
        partially_paid: "আংশিক পরিশোধিত",
        paid: "পরিশোধিত",
        cod_pending: "ক্যাশ অন ডেলিভারি",
        refunded: "টাকা ফেরত",
    },
    channel: {
        pos: "পিওএস",
        manual: "ম্যানুয়াল",
        facebook: "ফেসবুক",
        whatsapp: "হোয়াটসঅ্যাপ",
        phone: "ফোন",
        storefront: "ওয়েবসাইট",
    },
    actions: {
        confirmed: "কনফার্ম",
        packed: "প্যাক হয়েছে",
        shipped: "পাঠানো হয়েছে",
        delivered: "ডেলিভারি হয়েছে",
        returned: "ফেরত এসেছে",
        cancelled: "অর্ডার বাতিল",
        pending: "কনফার্মের জন্য পাঠান",
        edit: "সম্পাদনা",
        sendSms: "কনফার্মেশন এসএমএস পাঠান",
        merge: "এই অর্ডারে মিলিয়ে দিন",
        call: "কল",
        bulkConfirm: "বাছাইগুলো কনফার্ম",
    },
    done: {
        created: "অর্ডার তৈরি হয়েছে।",
        saved: "অর্ডার সংরক্ষিত হয়েছে।",
        status: "অর্ডার আপডেট হয়েছে।",
        merged: "অর্ডার মিলিয়ে দেওয়া হয়েছে।",
        smsSent: "কনফার্মেশন এসএমএস পাঠানো হয়েছে।",
        bulkQueued: "{{count}}টি অর্ডার কনফার্ম হচ্ছে…",
    },
    cancelConfirm: {
        title: "এই অর্ডার বাতিল করবেন?",
        description: "রিজার্ভ করা স্টক আবার পাওয়া যাবে। এটি ফেরানো যাবে না।",
        reason: "কারণ (ঐচ্ছিক)",
    },
    form: {
        titleNew: "নতুন অর্ডার",
        titleEdit: "{{number}} সম্পাদনা",
        descriptionNew: "ফোন নম্বর দিয়ে কাস্টমার খুঁজুন, পণ্য ও ঠিকানা দিন। সংরক্ষণের সময় মোট হিসাব যাচাই হবে।",
        customer: "কাস্টমার",
        phone: "মোবাইল নম্বর",
        lookup: "খুঁজুন",
        found: "কাস্টমার: {{name}}",
        notFound: "এই নম্বরে এখনো কোনো কাস্টমার নেই; অর্ডারে নম্বরটি থাকবে।",
        savedAddress: "সংরক্ষিত ঠিকানা",
        newAddress: "নতুন ঠিকানা লিখুন",
        recipient: "প্রাপকের নাম",
        division: "বিভাগ",
        district: "জেলা",
        upazila: "উপজেলা / থানা",
        addressLine: "বাসা, রোড, এলাকা",
        location: "যেখান থেকে পাঠানো হবে",
        channel: "চ্যানেল",
        products: "পণ্য",
        quantity: "পরিমাণ",
        unitPrice: "দাম",
        discountPercent: "ছাড় %",
        billDiscount: "অর্ডারে ছাড়",
        weight: "ওজন (গ্রাম)",
        deliveryCharge: "ডেলিভারি চার্জ",
        deliveryAuto: "জোন অনুযায়ী: {{zone}}",
        deliveryTyped: "হাতে লেখা (জোনের চার্জ বাদ)",
        useZone: "জোনের চার্জ নিন",
        advance: "অগ্রিম পাওয়া গেছে",
        advanceAccount: "কোন অ্যাকাউন্টে জমা",
        advanceAccountHint: "এই অর্ডারের পেমেন্ট হিসেবে রেকর্ড হবে।",
        advanceMethod: "পরিশোধের মাধ্যম",
        advanceReference: "ট্রানজ্যাকশন আইডি",
        note: "নোট",
        subtotal: "উপমোট",
        estimatedTotal: "আনুমানিক মোট",
        totalHint: "সংরক্ষণের সময় সার্ভার ভ্যাট ও চূড়ান্ত মোট হিসাব করবে।",
        saveDraft: "খসড়া সংরক্ষণ",
        savePending: "সংরক্ষণ করে কনফার্মের জন্য পাঠান",
        save: "পরিবর্তন সংরক্ষণ",
        noLines: "অন্তত একটি পণ্য যোগ করুন।",
    },
    detail: {
        lines: "পণ্য",
        totals: "মোট হিসাব",
        address: "ডেলিভারির ঠিকানা",
        timeline: "সময়রেখা",
        noAddress: "ডেলিভারির ঠিকানা নেই।",
        created: "তৈরি {{date}}",
        lineDiscount: "ছাড়",
        tax: "ভ্যাট",
        delivery: "ডেলিভারি",
        total: "মোট",
        advance: "অগ্রিম",
        duplicates: "সম্ভাব্য ডুপ্লিকেট",
        duplicatesBody: "একই ফোন থেকে কাছাকাছি সময়ে দেওয়া অন্য খোলা অর্ডার।",
        returned: "{{qty}} ফেরত",
        reason: "কারণ: {{reason}}",
    },
    calls: {
        title: "কল তালিকা",
        description: "কনফার্মের অপেক্ষায় থাকা অর্ডার। কাস্টমারকে কল করে কনফার্ম বা বাতিল করুন।",
        empty: "কোনো অর্ডার কনফার্মের অপেক্ষায় নেই।",
        bulkDone: "{{ok}}টি কনফার্মড, {{failed}}টি কনফার্ম হয়নি।",
        failedRow: "{{number}}: {{reason}}",
    },
    zones: {
        title: "ডেলিভারি জোন",
        description: "এলাকা অনুযায়ী ডেলিভারি চার্জ। অর্ডারের পাতা ঠিকানা দেখে জোন বেছে নেয়।",
        name: "জোনের নাম",
        baseCharge: "মূল চার্জ",
        freeWeight: "অন্তর্ভুক্ত ওজন (গ্রাম)",
        weightStep: "এরপর প্রতি (গ্রাম)",
        stepCharge: "প্রতি ধাপে চার্জ",
        daysMin: "ডেলিভারি (কমপক্ষে, দিন)",
        daysMax: "ডেলিভারি (সর্বোচ্চ, দিন)",
        daysHint: "পণ্যের পাতায় ক্রেতারা দেখবেন, যেমন ১–২ দিন। দেখাতে না চাইলে ফাঁকা রাখুন।",
        isDefault: "ডিফল্ট জোন (অন্য কোথাও নেই এমন এলাকা)",
        areas: "এলাকা",
        addArea: "এলাকা যোগ",
        wholeDistrict: "পুরো জেলা",
        noAreas: "কোনো এলাকা নেই।",
        add: "জোন যোগ",
        archive: "আর্কাইভ",
        saved: "জোন সংরক্ষিত হয়েছে।",
        settings: "অর্ডারের সেটিংস",
        duplicateWindow: "ডুপ্লিকেট সতর্কতার সময় (ঘণ্টা)",
        autoSms: "অর্ডার কনফার্মের অপেক্ষায় গেলে কনফার্মেশন এসএমএস পাঠান",
        settingsSaved: "সেটিংস সংরক্ষিত হয়েছে।",
    },
    confirm: {
        title: "আপনার অর্ডার কনফার্ম করুন",
        from: "{{shopName}} থেকে অর্ডার {{number}}",
        delivery: "ডেলিভারি",
        total: "মোট",
        confirm: "হ্যাঁ, অর্ডার কনফার্ম করছি",
        cancel: "অর্ডার বাতিল করুন",
        confirmed: "ধন্যবাদ! আপনার অর্ডার কনফার্ম হয়েছে।",
        cancelled: "আপনার অর্ডার বাতিল হয়েছে।",
        closed: "এই লিংক আর ব্যবহার করা যাবে না।",
        notFound: "এই লিংকটি সঠিক নয়।",
    },
};
//# sourceMappingURL=orders.js.map